import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "current-user__name" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.tag), { class: "current-user" }, {
    default: _withCtx(() => [
      (_ctx.currentUser)
        ? _renderSlot(_ctx.$slots, "default", {
            key: 0,
            user: _ctx.currentUser
          }, () => [
            _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.displayName), 1)
          ])
        : _createCommentVNode("", true)
    ]),
    _: 3
  }))
}